









































import Vue from "vue";
import Shared from "../shared";
import storeHelper from "../store/store-helper";
import Alert from "../components/alerts/alert.vue";
import PortalGroupedList from "../components/PortalGroupedList.vue";
import { UserPatch, Portal } from "@infoland/iprova-api";
import Utils from "@/utils";
import { cookies } from "@/enums";
import Toolbar from "../components/toolbar/Toolbar.vue";
import { SnackBarTimeout } from "@/enums";

export default Vue.extend({
    name: "WelcomeComponent",
    components: { Alert, PortalGroupedList, Toolbar },
    data: () => {
        return {
            alertOptions: { outlined: true, prominent: true, showImage: false }
        };
    },
    computed: {
        portals(): Portal[] {
            return storeHelper.portalStore.portals;
        },
        noPortals(): boolean {
            return this.portals?.length == 0;
        }
    },
    async beforeRouteEnter(to, from, next) {
        const user = await storeHelper.userStore.getLoggedOnUser();
        if (Utils.isAnonymousUser(user.user_id) && storeHelper.portalStore.portals.length == 0) {
            //anonymous without any available portals => login
            Utils.navigateToLogin();
            //cancel navigation to this component
            next(false);
        } else {
            next(); //continue
        }
    },
    created() {
        document.title = Utils.getPageTitle(this.$t("general.route.welcome") as string, "after");
    },
    methods: {
        async redirectToSelectedPortal(portalItem: any) {
            const user = {
                start_portal_id: portalItem.id
            };
            if (!Utils.isAnonymousUser(this.$user.user_id)) {
                const result = await storeHelper.userStore.saveUserAsync(this.$user.user_id, user as UserPatch);
                if (result) {
                    storeHelper.siteStore.setSnackBarMessage(
                        this.$t("portal.messages.setStartPortalSuccessfully", {
                            var1: portalItem.title
                        }).toString(),
                        false,
                        SnackBarTimeout.short
                    );
                    this.$router.push({ name: "Portal", params: { portalId: portalItem.id.toString() } });
                } else {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
                }
            } else {
                //for anonymous user the startPortal is not saved into DB, is just kept into a cookie
                Utils.setCookie(cookies.StartPortal, portalItem.id);
                this.$router.push({ name: "Portal", params: { portalId: portalItem.id.toString() } });
            }
        }
    }
});
